import { render } from "./OnboardingScreens.vue?vue&type=template&id=44157f96"
import script from "./OnboardingScreens.vue?vue&type=script&lang=js"
export * from "./OnboardingScreens.vue?vue&type=script&lang=js"

import "./OnboardingScreens.vue?vue&type=style&index=0&id=44157f96&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__